import getCurrentBrand from "./getCurrentBrand";

export default predefined => JSON.stringify({
  "guest_form": {
    "name": {
      "editable": false,
      "visible": false,
      "value": predefined.name,
    },
    "email": {
      "editable": false,
      "visible": false,
      "value": predefined.email,
    },
  },
  "question_form": {
    "custom_fields": {
      "country": {
        "visible": false,
        "editable": false,
        "value": "", // @todo 2018-10-09 ?
      },
      "boutique": {
        "visible": true,
        "editable": false,
        "value": predefined.boutique
      },
      "request-type": {
        "visible": true,
        "editable": true,
        "value": [
          "Add a user to this team",
          "Other"
        ],
      },
      "attachment": {
        "visible": true,
        "editable": true
      },
      "brand": {
        "visible": false,
        "editable": false,
        "value": getCurrentBrand()
      },
    },
  },
});
